import React from 'react';

import { Skeleton } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { AvatarSize } from '../../../../shared/constants';
import { useStyles } from './CommunityListItemSkeleton.styles';

export default function CommunityListItemSkeleton() {
  const theme = useTheme();
  const { classes } = useStyles(theme);

  return (
    <div className={classes.communityWrapper}>
      <Skeleton
        variant="circular"
        width={AvatarSize.m}
        height={AvatarSize.m}
        animation="wave"
      />
      <div className={classes.communityDetails}>
        <div className={classes.infoWrapper}>
          <Skeleton variant="text" width="62%" height={28} animation="wave" />
          <Skeleton variant="text" width="38%" height={18} animation="wave" />
          <Skeleton variant="text" width="88%" height={18} animation="wave" />
        </div>
        <div className={classes.controlWrapper}>
          <Skeleton
            variant="rounded"
            width={100}
            height={36}
            animation="wave"
          />
        </div>
      </div>
    </div>
  );
}
